import { AddFilterRuleRequest, RULE_SET_ROUTES } from "@zeal/common";
import { IAxiosInstance } from "../../../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../../../AbstractApiClient/IApiResponse";

export const addFilterRule = (axios: IAxiosInstance) => {
  return async (data: AddFilterRuleRequest) => {
    const response = await axios.noRetry.post<IApiResponse<any>>(
      `${RULE_SET_ROUTES.ADD_FILTER_RULE.replace(
        ":companyID",
        data.companyID
      ).replace(":ruleSetID", data.ruleSetID)}`,
      data
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
